import React, { useState } from 'react';
import { Collapse, Icon, Input } from 'antd';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import { useHomeCustomizationStore } from './store';
import Link from './Link';
import AddNewItemButton from './AddNewItemButton';
import useDebounce from 'react-use/lib/useDebounce';
import DragHandle from 'components/miscellaneous/DragHandle';

const SortableList = SortableContainer(({ children }) => {
  return <div className="space-y-4">{children}</div>;
});

const SortableItem = SortableElement(({ children }) => {
  return <>{children}</>;
});

export default function LinkGroup({ group }) {
  const [name, setName] = useState(group.name);
  const {
    updateGroup,
    addNewLink,
    updateLinkOrders,
    removeGroup,
  } = useHomeCustomizationStore();

  useDebounce(
    () => {
      updateGroup({ id: group.id, name });
    },
    200,
    [name, group.id],
  );

  return (
    <div className="w-full">
      <Collapse accordion>
        <Collapse.Panel
          header={
            <div
              className="flex w-full items-center"
              style={{ justifyContent: 'space-between' }}
            >
              <div className="flex items-center space-x-2">
                <Input
                  placeholder="Group Name"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  onClick={e => e.stopPropagation()}
                />
              </div>
              <div className="flex items-center space-x-2">
                <Icon
                  style={{ fontSize: 16 }}
                  theme="twoTone"
                  twoToneColor="#ff3333"
                  type="delete"
                  onClick={e => {
                    e.stopPropagation();
                    removeGroup(group.id);
                  }}
                />
                <DragHandle />
              </div>
            </div>
          }
          key={1}
        >
          <SortableList
            useDragHandle
            onSortEnd={({ oldIndex, newIndex }) => {
              updateLinkOrders(
                group.id,
                arrayMove(group.homePageLinks, oldIndex, newIndex),
              );
            }}
          >
            {group.homePageLinks.map((item, index) => {
              return (
                <SortableItem index={index} key={item.id}>
                  <Link groupId={group.id} homePageLink={item} />
                </SortableItem>
              );
            })}
          </SortableList>
          <AddNewItemButton
            text="Add Link"
            onClick={() => addNewLink(group.id)}
          />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
